export interface LookupResult {
  Items: LookupResultItem[];
}

export interface LookupResultSuccessItem {
  Id: string;
  Description: string;
  Highlight: string;
  Text: string;
  Type: string;
}

export interface LookupResultErrorItem {
  Cause: string;
  Description: string;
  Error: string;
  Resolution: string;
}

export interface RetrieveResult {
  Items: RetrieveResultItem[];
}

export interface RetrieveResultItem {
  AdminAreaCode: string;
  AdminAreaName: string;
  Barcode: string;
  Block: string;
  BuildingName: string;
  BuildingNumber: string;
  City: string;
  Company: string;
  CountryIso2: string;
  CountryIso3: string;
  CountryIsoNumber: string;
  CountryName: string;
  DataLevel: string;
  Department: string;
  District: string;
  DomesticId: string;
  Id: string;
  Label: string;
  Language: string;
  LanguageAlternatives: string;
  Line1: string;
  Line2: string;
  Line3: string;
  Line4: string;
  Line5: string;
  Neighbourhood: string;
  POBoxNumber: string;
  PostalCode: string;
  Province: string;
  ProvinceCode: string;
  ProvinceName: string;
  SecondaryStreet: string;
  SortingNumber1: string;
  SortingNumber2: string;
  Street: string;
  SubBuilding: string;
  Type: string;
}

export type LookupResultItem = LookupResultSuccessItem | LookupResultErrorItem;
